export default "__VITE_PUBLIC_ASSET__d8f9996c__"